<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="dashboardRoute"
                                    >Portada</router-link
                                >
                            </li>
                            <li>
                                <span>Vehículos</span>
                            </li>
                            <li class="active">
                                <span>Lista de vehículos</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        Lista de vehículos
                    </h2>
                    <small>Gestionar vehículos</small>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Vehículos
                </div>
                <div class="panel-body">
                    <div class="m-b-md">
                        <div class="m-b-sm">
                            <button
                                class="btn btn-default"
                                type="button"
                                data-toggle="collapse"
                                data-target="#vehicleListFilters"
                                aria-expanded="false"
                                @click="toggleFilter"
                                aria-controls="vehicleListFilters"
                            >
                                Filtros
                                <i
                                    :class="
                                        'fa fa-caret-' +
                                            (filterFlag ? 'down' : 'up')
                                    "
                                ></i>
                            </button>
                            <router-link
                                class="btn btn-primary btn-outline pull-right"
                                tag="button"
                                :to="vehicleNewRoute"
                            >
                                Crear <i class="fa fa-plus"></i
                            ></router-link>
                        </div>
                        <div class="collapse" id="vehicleListFilters">
                            <div class="form">
                                <div class="row">
                                    <div class="col-md-3 form-group">
                                        <label>Placa</label>
                                        <custom-input
                                            tipo="text"
                                            :field="$v.filters.plate"
                                        />
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Marca</label>
                                        <custom-input
                                            tipo="select"
                                            :field="$v.filters.brand"
                                            :items="carBrands"
                                        />
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Tipo</label>
                                        <custom-input
                                            tipo="select"
                                            :field="$v.filters.type"
                                            :items="types"
                                        />
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Estado</label>
                                        <custom-input
                                            tipo="select"
                                            :field="$v.filters.status"
                                            :items="statuses"
                                        />
                                    </div>
                                </div>
                                <div class="row text-center">
                                    <div class="col-md-12">
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                            @click="clear"
                                        >
                                            Limpiar filtros
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-primary"
                                            @click="search"
                                        >
                                            Aplicar filtros
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table
                            cellpadding="1"
                            cellspacing="1"
                            class="table table-bordered table-striped"
                        >
                            <thead>
                                <tr>
                                    <th>Usuario</th>
                                    <th>Placa</th>
                                    <th>Marca</th>
                                    <th>Color</th>
                                    <th>Tipo</th>
                                    <th>Conductor</th>
                                    <th>DNI</th>
                                    <th>Celular</th>
                                    <th>Estado</th>
                                    <th style="width:6%">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="o in data" :key="o.id">
                                    <td align="center">
                                        <span>{{ o.username }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.plate }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.brand }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ getColorDesc(o.color) }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ getTypeDesc(o.type) }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.driverName }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.driverId }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.driverPhone }}</span>
                                    </td>
                                    <td align="center">
                                        <status-badge :status="o.status" />
                                    </td>
                                    <td align="center" class="action-cell">
                                        <div class="dropdown">
                                            <a
                                                type="button"
                                                class="dropdown-toggle"
                                                data-toggle="dropdown"
                                                ><i class="fa fa-gear"></i
                                            ></a>
                                            <ul
                                                class="dropdown-menu filedropdown m-l pull-right"
                                            >
                                                <li>
                                                    <a @click="goToEdit(o.id)"
                                                        >EDITAR</a
                                                    >
                                                </li>
                                                <li>
                                                    <a
                                                        @click="
                                                            toggleVehicleState(
                                                                o.id,
                                                                o.status
                                                            )
                                                        "
                                                        >{{
                                                            o.status === 1
                                                                ? "INACTIVAR"
                                                                : "ACTIVAR"
                                                        }}</a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <paginator
                        :total-elements="totalElements"
                        :page-number="pageNumber"
                        :total-pages="totalPages"
                        :change-page="changePage"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    DASHBOARD,
    VEHICLE_EDIT,
    VEHICLE_LIST,
    VEHICLE_NEW
} from "../../router/routes";
import CustomInput from "../common/CustomInput.vue";
import StatusBadge from "../common/StatusBadge.vue";
import * as carBrands from "../../assets/json/carBrands";
import {
    colorList,
    vehicleStatusList,
    vehicleTypeList
} from "../../util/selectOptions";
import { paginationMixin } from "../../util/paginationMixin";
import { filterMixin } from "../../util/filterMixin";
import Alert from "../../util/alert";
import VehicleService from "../../services/VehicleService";
import Util from "../../util/util";

export default {
    name: VEHICLE_LIST.name,
    mixins: [paginationMixin, filterMixin],
    components: { CustomInput, StatusBadge },
    data: () => ({
        dashboardRoute: DASHBOARD.route,
        vehicleNewRoute: VEHICLE_NEW.route,
        data: [],
        statuses: vehicleStatusList,
        types: vehicleTypeList,
        carBrands: carBrands,
        filters: {
            plate: null,
            brand: null,
            type: null,
            status: null
        }
    }),
    validations: {
        filters: {
            plate: {},
            brand: {},
            type: {},
            status: {}
        }
    },
    methods: {
        async init() {
            const self = this;

            let activeState = {
                key: 1,
                value: "ACTIVO"
            };

            self.filters.status = activeState
            self.getData({ status: activeState.key });
        },
        search() {
            this.$v.$touch();
            if (this.$v.$error) return;
            const self = this;

            const data = {
                ...self.filters,
                ...{
                    brand: self.filters.brand ? self.filters.brand.key : null,
                    type: self.filters.type ? self.filters.type.key : null,
                    status: self.filters.status ? self.filters.status.key : null
                }
            };
            self.getData(data);
        },
        clear() {
            const self = this;
            self.filters.plate = self.filters.brand = self.filters.type = self.filters.status = null;
            self.$v.$reset();
        },
        goToEdit(vehicleId) {
            this.$router.push({
                path: VEHICLE_EDIT.route.replace(":vehicleId", vehicleId)
            });
        },
        onToggleState(vehicle) {
            const self = this;
            const vehicles = self.data.filter(o => {
                return o.id === vehicle.id;
            });
            const vehicleFiltered =
                vehicles && vehicles.length > 0 ? vehicles[0] : null;
            const index = self.data.indexOf(vehicleFiltered);
            self.$set(self.data, index, vehicle);
        },
        getTypeDesc(type) {
            return Util.getOptionByKey(vehicleTypeList, type).value;
        },
        getColorDesc(color) {
            return Util.getOptionByKey(colorList, color).value;
        },
        async toggleVehicleState(vehicleId, source) {
            try {
                const status = source === 1 ? 2 : 1;
                const vehicleUpdated = (
                    await VehicleService.toggleVehicleState(vehicleId, status)
                ).data.payload;
                this.onToggleState(vehicleUpdated);
            } catch (err) {
                Alert.mensajeError(err.message);
            }
        },
        async getData(params = {}, page = 1) {
            params.page = page - 1;
            params.size = this.pageSize;
            this.params = params;
            this.loading = true;
            const payload = (await VehicleService.filterVehicles(params)).data
                .payload;
            this.data = payload.content;
            this.totalPages = payload.totalPages;
            this.totalElements = payload.totalElements;
            this.pageNumber = payload.number + 1;
            this.loading = false;
        }
    },
    async mounted() {
        const self = this;
        self.init();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/vehicle/VehicleList.vue